'use client'

import { motion } from 'framer-motion'
import React from "react";
import { staggerContainerVariants, headerVariants, fadeInVariants } from '@/lib/animations';

interface SectionProps {
    title: string | React.ReactNode;
    titleTag: string;
    subTitle: string | null;
    subTitleTag: string | null;
    description: string | null;
    descriptionTag: string | null;
}

// Animation variants imported from centralized library

export default function SectionTitle({title, titleTag, subTitle, subTitleTag, description, descriptionTag}: SectionProps) {
    // Dinamik HTML tag'lerini component olarak kullanmak için büyük harfle değişkene atama
    // Eğer tag belirtilmemişse varsayılan tag'leri kullan
    const TitleTag = (titleTag || 'h2') as React.ElementType;
    const SubTitleTag = (subTitleTag || 'p') as React.ElementType;
    const DescriptionTag = (descriptionTag || 'p') as React.ElementType;

    return (
        <motion.div
            variants={staggerContainerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="text-center flex flex-col w-full max-w-full sm:max-w-11/12 md:max-w-10/12 lg:max-w-9/12 xl:max-w-8/12 2xl:max-w-7/12 mx-auto px-4 sm:px-6"
        >
            {subTitle && (
                <motion.div variants={headerVariants}>
                    <SubTitleTag data-prop-path="subTitle" className="font-display text-2xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-[2.5rem] text-alsero-first leading-snug">
                        {subTitle}
                    </SubTitleTag>
                </motion.div>
            )}

            <motion.div variants={headerVariants}>
                <TitleTag data-prop-path="title" className="font-sans text-alsero-second text-3xl sm:text-4xl md:text-4xl lg:text-5xl xl:text-5xl 2xl:text-6xl font-semibold leading-tight sm:leading-snug md:leading-relaxed lg:leading-14">
                    {title}
                </TitleTag>
            </motion.div>

            {description && (
                <motion.div variants={fadeInVariants}>
                    <DescriptionTag data-prop-path="description" className="font-sans mt-4 sm:mt-5 md:mt-6 text-sm sm:text-base md:text-lg text-[#7F7F7F]">
                        {description}
                    </DescriptionTag>
                </motion.div>
            )}

        </motion.div>
    )
}

